import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { FxpLoggerService } from '@fxp/fxpservices';

export class TelemetryService {
    private static instance: TelemetryService;
    private loggerService: FxpLoggerService;

    private constructor() {
        this.loggerService = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.FxpLoggerService) as FxpLoggerService;
    }

    public static getInstance(): TelemetryService {
        if (!TelemetryService.instance) {
            TelemetryService.instance = new TelemetryService();
        }
        return TelemetryService.instance;
    }
    
    getCorrelationId(): string {
        return this.loggerService.getCorrelationId();
    }

    public createPropertyBag() {
        return this.loggerService.createPropertyBag();
    }

    public renewTransactionId() {
        return this.loggerService.renewCorrelationId();
    }

    public renewSubTransactionId() {
        return this.loggerService.renewSubCorrelationId();
    }

    public getTransactionId() {
        return this.loggerService.getCorrelationId();
    }

    public getSubTransactionId() {
        return this.loggerService.getSubCorrelationId();
    }    public logTrace(
        source: string,
        methodName: string,
        message: string,
        properties: any = null,
        correlationid: any = null
    ) {

        const eventProperties = this.loggerService.createPropertyBag();
        if (properties) {
            for (const key of Object.keys(properties)) {
                eventProperties.addToBag(key, properties[key]);
            }
        }
        if (correlationid) {
            eventProperties.addToBag('correlationId', correlationid);
        }
        this.loggerService.logTrace(source + '.' + methodName, message, eventProperties);
    }public logEvent(
        source: string,
        methodName: string,
        eventName: string,
        propertyBag: any = null,
        correlationid: any = null
    ) {

        const eventProperties = this.loggerService.createPropertyBag();
        if (propertyBag) {
            for (const key of Object.keys(propertyBag)) {
                eventProperties.addToBag(key, propertyBag[key]);
            }
        }
        if (correlationid) {
            eventProperties.addToBag('correlationId', correlationid);
        }
        this.loggerService.logEvent(
            source + '.' + methodName,
            'EditAvailability.' + eventName,
            eventProperties
        );
    }

    public logWarning(
        source: string,
        methodName: string,
        message: string,
        propertyBag: any = null,
        correlationid: any = null
    ) {
        const eventProperties = this.loggerService.createPropertyBag();
        if (propertyBag) {
            for (const key of Object.keys(propertyBag)) {
                eventProperties.addToBag(key, propertyBag[key]);
            }
        }
        if (correlationid) {
            eventProperties.addToBag('correlationId', correlationid);
        }
        this.loggerService.logWarning(source + '.' + methodName, message, eventProperties);
    }

    public logError(
        componentName: string,
        methodName: string,
        err: any,
        errCode: any,
        propertyBag: any = null,
        correlationid: any = null,
        errorSeverity: any = null
    ) {
        const eventProperties = this.loggerService.createPropertyBag();
        if (propertyBag) {
            for (const key of Object.keys(propertyBag)) {
                eventProperties.addToBag(key, propertyBag[key]);
            }
        }
        if (correlationid) {
            eventProperties.addToBag('correlationId', correlationid);
        }
        if (errorSeverity) {
            eventProperties.addToBag('severityLevel', errorSeverity);
        }

        if (errCode == 404) {
            this.loggerService.logTrace(
                componentName + '.' + methodName,
                err,
                eventProperties
            );
        } else {
            this.loggerService.logError(
                componentName + '.' + methodName,
                err,
                errCode,
                "Stack Trace",
                eventProperties
            );
        }
    }    public logPageView(
        pageName: string,
        properties: any = null
    ) {
        const eventProperties = this.loggerService.createPropertyBag();
        if (properties) {
            for (const key of Object.keys(properties)) {
                eventProperties.addToBag(key, properties[key]);
            }
        }
        this.loggerService.trackPageView(pageName, eventProperties);
    }
}
